import index from "../../../../../_virtual/index2.js";
index.objectify;
index.parse;
index.async;
index.sync;
export {
  index as default
};
//# sourceMappingURL=index.js.map
